/**
 * Global application configuration.
 * Can store run-time options, API urls, paths, execution flags and so on.
 * Automatically loaded on application initialization and available as app.config.
 */

'use strict';

// public
module.exports = {
    list: {
        filterStatus: null,
        filterSearch: '',
        sort: 0
    },
    constants: {
        sort: {
            BY_NAME: 0,
            BY_CATEGORY: 1,
            BY_DATE: 2
        }
    },
    extensions: {
        registered: [
            'mpg',
            'mpeg',
            'mkv',
            'avi',
            '3gp',
            'ts',
            'tspinf',
            'm4a',
            'mp3',
            'mp4',
            'ac3',
            'mov',
            'vob',
            'wav',
            'ape',
            'mts',
            'm2t',
            'm2v',
            'ogg',
            'oga',
            'divx',
            'aiff',
            'm2ts',
            'wv',
            'm2p',
            'tp',
            'flv',
            'tta',
            'mod',
            'tod',
            'asf',
            'wma',
            'wmv',
            'flac',
            'ape',
            'cue',
            'm3u',
            'm3u8',
            'jpg',
            'jpeg',
            'png',
            'bmp',
            'tif',
            'tiff',
            'iso',
            'aac',
            'txt',
            'srt',
            'sub',
            'ass',
            'm4v',
            'tts'
        ]
    }
};
